module.exports = __webpack_public_path__ + "img/logo-white.0e3472fc.png";